// extracted by mini-css-extract-plugin
export default {"buttons":"_6e_pwr","recover":"YRTglU","startOver":"KbXeJF","title":"hFkwAi"};